import { useState, useEffect } from "react";

export default function MenuImageSection() {
  const pages = [
    "/menu/menu_page-0001.jpg",
    "/menu/menu_page-0002.jpg",
    "/menu/menu_page-0003.jpg",
    "/menu/menu_page-0004.jpg",
    "/menu/menu_page-0005.jpg",
    "/menu/menu_page-0006.jpg",
    "/menu/menu_page-0007.jpg",
    "/menu/menu_page-0008.jpg",
  ];

  const [loaded, setLoaded] = useState({});
  const [minTimeDone, setMinTimeDone] = useState(false);

  // ⭐ 1 Second Minimum Loader
  useEffect(() => {
    const timer = setTimeout(() => {
      setMinTimeDone(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <section style={styles.section}>
      <div style={styles.container}>
        {pages.map((src, index) => {
          const showImage = loaded[index] && minTimeDone;

          return (
            <div key={index} style={styles.pageWrapper}>
              {!showImage && <div style={styles.skeleton} />}

              <img
                src={src}
                alt={`Menu Page ${index + 1}`}
                loading="lazy"
                onLoad={() =>
                  setLoaded(prev => ({ ...prev, [index]: true }))
                }
                style={{
                  ...styles.image,
                  opacity: showImage ? 1 : 0
                }}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
}

const styles = {
  section: {
    padding: "40px 16px",
    display: "flex",
    justifyContent: "center"
  },

  container: {
    width: "100%",
    maxWidth: 900
  },

  pageWrapper: {
    position: "relative",
    marginBottom: 20
  },

  image: {
    width: "100%",
    borderRadius: 12,
    transition: "opacity 0.4s ease",
    backgroundColor: "#422913"
  },

  skeleton: {
    position: "absolute",
    width: "100%",
    height: 500,
    borderRadius: 12,
   background: 
  "linear-gradient(90deg,#e7d8c5 25%, #5a3a1f 50%, #e7d8c5 75%)",
    backgroundSize: "400% 100%",
    animation: "shimmer 1.4s ease infinite"
  }
};
